var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscovery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.11 22.883l3.502 6.013 7.667-4.405-3.494-6.044L.11 22.883z",
    fill: "#DDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.11 22.883l3.502 6.013 7.667-4.405-3.494-6.044L.11 22.883z",
    fill: "url(#paint0_linear_5411_1054)",
    fillOpacity: 0.85
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M.11 22.883l3.502 6.013 7.667-4.405-3.494-6.044L.11 22.883z",
    fill: "url(#paint1_linear_5411_1054)",
    fillOpacity: 0.85
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.49 19.714l1.85-1.079-4.956-8.594L9 16.057c1.45 2.498 4.75 8.162 4.75 8.162l1.213-.65c.019-.01.043 0 .065 0L8.02 38.75h2.746l7.739-16.738 1.815-1.047L27.97 36.25h2.812L22.49 19.714zM20.475 7.5c1.938 3.3 4.707 8.145 6.75 11.622l12.68-7.325L33.13.11 20.475 7.5z",
    fill: "#DDD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.49 19.714l1.85-1.079-4.956-8.594L9 16.057c1.45 2.498 4.75 8.162 4.75 8.162l1.213-.65c.019-.01.043 0 .065 0L8.02 38.75h2.746l7.739-16.738 1.815-1.047L27.97 36.25h2.812L22.49 19.714zM20.475 7.5c1.938 3.3 4.707 8.145 6.75 11.622l12.68-7.325L33.13.11 20.475 7.5z",
    fill: "url(#paint2_linear_5411_1054)",
    fillOpacity: 0.85
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.49 19.714l1.85-1.079-4.956-8.594L9 16.057c1.45 2.498 4.75 8.162 4.75 8.162l1.213-.65c.019-.01.043 0 .065 0L8.02 38.75h2.746l7.739-16.738 1.815-1.047L27.97 36.25h2.812L22.49 19.714zM20.475 7.5c1.938 3.3 4.707 8.145 6.75 11.622l12.68-7.325L33.13.11 20.475 7.5z",
    fill: "url(#paint3_linear_5411_1054)",
    fillOpacity: 0.85
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5411_1054",
    x1: -0.418,
    y1: 28.896,
    x2: 11.279,
    y2: 28.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#DD0510"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958,
    stopColor: "#7D0006"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5411_1054",
    x1: -0.418,
    y1: 28.896,
    x2: 11.279,
    y2: 28.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6C0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F68084"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5411_1054",
    x1: 6.512,
    y1: 38.75,
    x2: 39.906,
    y2: 38.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#DD0510"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958,
    stopColor: "#7D0006"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5411_1054",
    x1: 6.512,
    y1: 38.75,
    x2: 39.906,
    y2: 38.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6C0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F68084"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscovery);
export default __webpack_public_path__ + "static/media/discovery.473ea8b12aeac2110dd84ec8a36beb2e.svg";
export { ForwardRef as ReactComponent };